<!-- ========== PAGE HERO ========== -->
<section class="ds-page-hero">
  <div class="ds-orb ds-orb--soft ds-page-hero__orb-1"></div>
  <div class="ds-orb ds-orb--cobalt ds-page-hero__orb-2"></div>
  <div class="container ds-page-hero__inner">
    <span class="ds-pill">KVKK</span>
    <h1>Aydınlatma Metni</h1>
    <p class="ds-lead">
      6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında kişisel
      verilerinizi nasıl işlediğimizi açıklıyoruz.
    </p>
  </div>
</section>

<!-- ds-legal => scroll-reveal gözlemcisinden muaftır (app.component.ts) -->
<section class="ds-section ds-legal">
  <div class="container">
    <div class="ds-legal__doc">

      <p class="ds-legal__meta">
        Son güncelleme:
        <time [attr.datetime]="lastUpdated.iso">{{ lastUpdated.label }}</time>
      </p>

      <nav class="ds-legal__toc" aria-label="İçindekiler">
        <h2>İçindekiler</h2>
        <ol>
          <li><a href="#veri-sorumlusu">Veri Sorumlusunun Kimliği</a></li>
          <li><a href="#kapsam">Bu Metnin Kapsamı</a></li>
          <li><a href="#islenen-veriler">İşlenen Kişisel Verileriniz</a></li>
          <li><a href="#amaclar">İşleme Amaçları</a></li>
          <li><a href="#toplama">Toplama Yöntemleri</a></li>
          <li><a href="#hukuki-sebep">Hukuki Sebepler</a></li>
          <li><a href="#aktarim">Kişisel Verilerin Aktarılması</a></li>
          <li><a href="#yurt-disi">Yurt Dışına Aktarım</a></li>
          <li><a href="#sesli-gorusme">Sesli Görüşmeler ve Çağrı Kaydı</a></li>
          <li><a href="#otomatik">Otomatik Sistemlerle İşleme</a></li>
          <li><a href="#saklama">Saklama Süreleri</a></li>
          <li><a href="#guvenlik">Veri Güvenliği</a></li>
          <li><a href="#ihlal">Veri İhlali Bildirimi</a></li>
          <li><a href="#haklariniz">İlgili Kişi Olarak Haklarınız</a></li>
          <li><a href="#basvuru">Başvuru Yöntemleri</a></li>
          <li><a href="#degisiklik">Metindeki Değişiklikler</a></li>
        </ol>
      </nav>

      <h2 id="veri-sorumlusu">1. Veri Sorumlusunun Kimliği</h2>
      <p>
        İşbu Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu
        (<strong>"KVKK"</strong> veya <strong>"Kanun"</strong>) uyarınca, veri
        sorumlusu sıfatıyla <strong>Keyo Dijital Çözümler A.Ş.</strong>
        (<strong>"Şirket"</strong> veya <strong>"Keyo AI"</strong>) tarafından
        hazırlanmıştır.
      </p>
      <p>
        Şirketimiz, hem <a href="https://keyo-ai.com">keyo-ai.com</a> internet
        sitesi ziyaretçilerine hem de Keyo AI hizmetlerinden yararlanan
        müşterilerine ait kişisel verilerin işlenmesi, korunması ve saklanması
        süreçlerinde KVKK ve ilgili mevzuata uygun şekilde hareket etmektedir.
      </p>
      <app-veri-sorumlusu></app-veri-sorumlusu>

      <h2 id="kapsam">2. Bu Metnin Kapsamı</h2>
      <p>
        Keyo AI, e-ticaret işletmeleri için yapay zeka destekli müşteri hizmetleri
        asistanları sunan bir platformdur. Akıllı sohbet asistanı, sesli asistan
        (Voice Agent) ile Instagram, Messenger, WhatsApp ve Telegram üzerinde
        çalışan asistanlar aracılığıyla; işletmenin sağladığı ürün kataloğu, sıkça
        sorulan sorular ve kurumsal bilgilerle eğitilerek son kullanıcıların
        sorularını yanıtlar, sipariş durumu sorgular ve ürün önerir.
      </p>
      <p>
        Bu ayrım, haklarınızı kime karşı kullanacağınızı belirlediği için önemlidir:
      </p>
      <ul>
        <li>
          <strong>Şirketimizin veri sorumlusu olduğu haller:</strong> keyo-ai.com
          internet sitesini ziyaret etmeniz, iletişim formunu doldurmanız, demo
          talebinde bulunmanız ve hizmetlerimizi doğrudan kullanmanız hâlinde
          Şirketimiz veri sorumlusu sıfatıyla hareket eder. Bu metin öncelikle bu
          halleri kapsar.
        </li>
        <li>
          <strong>Şirketimizin veri işleyen olduğu haller:</strong> Keyo AI
          asistanını kendi sitesine kuran bir işletmenin (satıcının) son
          müşterisiyseniz ve asistanla yaptığınız görüşme kapsamında verileriniz
          işleniyorsa, işleme amaç ve vasıtalarını <strong>ilgili satıcı</strong>
          belirler; bu ilişkide satıcı <strong>veri sorumlusu</strong>, Şirketimiz
          ise <strong>veri işleyen</strong> konumundadır. Bu kapsamdaki taleplerinizi
          öncelikle hizmeti aldığınız satıcıya yöneltmeniz gerekir; Şirketimiz
          satıcının talebi yanıtlamasına destek olur.
        </li>
      </ul>

      <h2 id="islenen-veriler">3. İşlenen Kişisel Verileriniz</h2>
      <h3>3.1. İnternet sitesi ziyaretçilerine ait veriler</h3>
      <ul>
        <li><strong>Kimlik Bilgileri:</strong> Ad, soyad.</li>
        <li><strong>İletişim Bilgileri:</strong> E-posta adresi, telefon numarası, şirket adı.</li>
        <li><strong>İşlem Güvenliği Verileri:</strong> IP adresi, tarayıcı türü ve sürümü, işletim sistemi, bağlantı zamanı, ziyaret edilen sayfalar.</li>
        <li><strong>Talep ve Şikâyet Bilgileri:</strong> İletişim formu, demo talebi ve diğer kanallar üzerinden ilettiğiniz mesaj içerikleri.</li>
      </ul>

      <h3>3.2. Keyo AI hizmetlerinin kullanımına ilişkin veriler</h3>
      <ul>
        <li><strong>Hesap ve Fatura Bilgileri:</strong> Yetkili kişi adı, e-posta adresi, telefon numarası, fatura adresi ve ödeme bilgileri. Kart numaralarının tamamı Şirketimiz tarafından saklanmaz; ödeme bilgileri ödeme hizmeti sağlayıcısı nezdinde işlenir.</li>
        <li><strong>Satıcı Yapılandırma Verileri:</strong> Ürün kataloğu, sıkça sorulan sorular, marka ses rehberi, politika dokümanları ve müşteri yorumları gibi asistanın eğitilmesi için sağlanan içerikler. Bu içerikler kişisel veri barındırabilir.</li>
        <li><strong>Görüşme İçeriği:</strong> Sohbet ve sesli kanallarda alınan girdiler ile asistanın ürettiği yanıtlar ve bu görüşmelerde yer alan kişisel veriler.</li>
        <li><strong>Ses ve Çağrı Verileri:</strong> Sesli asistan kullanıldığında görüşmenin sesi, gerçek zamanlı metne dönüştürülmüş hâli ve çağrı üstverisi (arayan numara, çağrı süresi). Ayrıntı için bkz. bölüm 9.</li>
        <li><strong>Sipariş Bilgileri:</strong> Sipariş takibi etkinleştirilmişse, yalnızca bir soru sorulduğu anda bağlı e-ticaret platformundan çekilen sipariş bilgileri. Geçmiş sipariş kayıtlarınız eğitim amacıyla içe aktarılmaz veya saklanmaz.</li>
        <li><strong>Kullanım Verileri:</strong> Hizmetle etkileşimleriniz, kullanılan özellikler ve işlem zamanları.</li>
      </ul>
      <p>
        Görüşme içerikleri ve satıcı verileri, <strong>genel amaçlı yapay zeka
        modellerinin eğitilmesinde kullanılmaz</strong>; birlikte çalıştığımız
        sağlayıcılar da kendilerine iletilen verileri bu amaçla kullanmaktan
        sözleşmesel olarak men edilmiştir.
      </p>

      <h2 id="amaclar">4. İşleme Amaçları</h2>
      <ul>
        <li>Hizmetlerin sunulması, asistanların kurulması, işletilmesi ve sürdürülmesi,</li>
        <li>Talep, şikâyet, öneri ve demo taleplerinin değerlendirilmesi ve sonuçlandırılması,</li>
        <li>Sözleşme süreçlerinin yürütülmesi, faturalandırma ve tahsilat işlemleri,</li>
        <li>İnternet sitesinin ve platformun güvenliğinin sağlanması, dolandırıcılık ve kötüye kullanımın önlenmesi,</li>
        <li>Hizmet kalitesinin ölçülmesi, hataların giderilmesi ve yeni özelliklerin geliştirilmesi (bu amaçla kural olarak toplulaştırılmış ve kimliksizleştirilmiş veriler kullanılır),</li>
        <li>Bilgi güvenliği süreçlerinin yürütülmesi,</li>
        <li>Yasal yükümlülüklerin yerine getirilmesi ve yetkili kamu kurum ve kuruluşlarının taleplerinin karşılanması,</li>
        <li>Açık rızanız bulunması hâlinde tanıtım, pazarlama faaliyetleri ve ticari elektronik ileti gönderimi.</li>
      </ul>

      <h2 id="toplama">5. Toplama Yöntemleri</h2>
      <p>Kişisel verileriniz;</p>
      <ul>
        <li>İnternet sitesindeki iletişim ve demo talep formlarının doldurulması,</li>
        <li>E-posta, telefon ve sosyal medya kanalları üzerinden bizimle iletişime geçmeniz,</li>
        <li>Keyo AI asistanları ile yazılı veya sesli görüşme yapmanız,</li>
        <li>Site kullanımınız sırasında sunucu kayıtlarının (log) otomatik olarak tutulması,</li>
        <li>Hizmetin kurulumu sırasında bağlanan e-ticaret ve mesajlaşma platformlarından veri alınması,</li>
      </ul>
      <p>yollarıyla, otomatik ve/veya otomatik olmayan yöntemlerle toplanmaktadır.</p>

      <h2 id="hukuki-sebep">6. Hukuki Sebepler</h2>
      <p>
        Kişisel verileriniz, Kanun'un 5. ve 6. maddelerinde öngörülen aşağıdaki
        hukuki sebeplere dayanılarak işlenmektedir:
      </p>
      <ul>
        <li>Kanunlarda açıkça öngörülmesi,</li>
        <li>Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması,</li>
        <li>Şirketimizin hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olması,</li>
        <li>Bir hakkın tesisi, kullanılması veya korunması için veri işlemenin zorunlu olması,</li>
        <li>İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, Şirketimizin meşru menfaatleri için veri işlenmesinin zorunlu olması,</li>
        <li>Yukarıdaki şartların bulunmadığı hâllerde açık rızanızın alınması.</li>
      </ul>

      <h2 id="aktarim">7. Kişisel Verilerin Aktarılması</h2>
      <p>
        Kişisel verileriniz, yukarıda belirtilen amaçlarla sınırlı olarak ve
        Kanun'un 8. ve 9. maddelerine uygun şekilde aşağıdaki alıcı gruplarına
        aktarılabilmektedir:
      </p>
      <ul>
        <li>Yetkili kamu kurum ve kuruluşları ile yargı mercileri,</li>
        <li>Hukuk, mali müşavirlik ve bağımsız denetim hizmeti alınan danışmanlar,</li>
        <li>Grup şirketlerimiz ve iş ortaklarımız,</li>
        <li>Hizmetin sunulabilmesi için gerekli olan ve aşağıda kategorileri belirtilen tedarikçi ve altyapı sağlayıcıları.</li>
      </ul>

      <h3>7.1. Hizmetin sunulmasında yer alan sağlayıcılar</h3>
      <p>
        Aşağıdaki sağlayıcılar, kişisel verileri Şirketimiz adına ve
        talimatlarımız doğrultusunda işler. Bir kanalı veya özelliği
        etkinleştirmediğiniz sürece, o kanala ilişkin sağlayıcıya veri
        aktarılmaz.
      </p>
      <div class="ds-legal__table-wrap">
        <table class="ds-legal__table">
          <caption>Hizmetin sunulmasında görev alan sağlayıcılar ve kendilerine aktarılan veriler.</caption>
          <thead>
            <tr>
              <th scope="col">Kategori</th>
              <th scope="col">Sağlayıcı</th>
              <th scope="col">Aktarılan Veri</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-label="Kategori">Yapay zeka</td>
              <td data-label="Sağlayıcı">Google</td>
              <td data-label="Aktarılan Veri">Görüşme içeriği ve satıcı yapılandırma verileri (yanıt üretimi için)</td>
            </tr>
            <tr>
              <td data-label="Kategori">Sesli asistan</td>
              <td data-label="Sağlayıcı">Vapi, ElevenLabs</td>
              <td data-label="Aktarılan Veri">Görüşme sesi, metne dönüştürülmüş hâli ve yanıt metni</td>
            </tr>
            <tr>
              <td data-label="Kategori">Telefon altyapısı</td>
              <td data-label="Sağlayıcı">Twilio</td>
              <td data-label="Aktarılan Veri">Çağrı üstverisi, telefon numarası, çağrı sesi</td>
            </tr>
            <tr>
              <td data-label="Kategori">Mesajlaşma kanalları</td>
              <td data-label="Sağlayıcı">Meta (Instagram, Messenger, WhatsApp), Telegram</td>
              <td data-label="Aktarılan Veri">İlgili kanal üzerinden yapılan yazışmalar</td>
            </tr>
            <tr>
              <td data-label="Kategori">E-ticaret platformları</td>
              <td data-label="Sağlayıcı">Shopify, ikas, Ticimax</td>
              <td data-label="Aktarılan Veri">Ürün kataloğu ve sipariş durumu sorguları</td>
            </tr>
            <tr>
              <td data-label="Kategori">Ödeme</td>
              <td data-label="Sağlayıcı">Stripe</td>
              <td data-label="Aktarılan Veri">Abonelik ödemesi ve faturalandırma bilgileri</td>
            </tr>
            <tr>
              <td data-label="Kategori">E-posta altyapısı</td>
              <td data-label="Sağlayıcı">E-posta ve sunucu hizmeti sağlayıcılarımız</td>
              <td data-label="Aktarılan Veri">İletişim formu içerikleri ve iletişim bilgileri</td>
            </tr>
            <tr>
              <td data-label="Kategori">Yazı tipi ve içerik dağıtım ağı</td>
              <td data-label="Sağlayıcı">Google Fonts, jsDelivr</td>
              <td data-label="Aktarılan Veri">IP adresi ve tarayıcı bilgisi (site görüntülenirken)</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        Yukarıdaki sağlayıcılar, yalnızca belgelenmiş talimatlarımız
        doğrultusunda hareket eder ve kişisel verileri kendi amaçları için —
        yapay zeka modeli eğitimi dâhil — kullanmaktan sözleşmesel olarak men
        edilmiştir. Altyapımız değiştikçe bu liste güncellenir; esasa ilişkin
        değişikliklerde bu metnin güncelleme tarihi yenilenir.
      </p>

      <h2 id="yurt-disi">8. Yurt Dışına Aktarım</h2>
      <p>
        Yukarıda belirtilen sağlayıcıların bir kısmı Türkiye dışında yerleşiktir;
        bu nedenle kişisel verileriniz hizmetin sunulması kapsamında yurt dışına
        aktarılmaktadır.
      </p>
      <p>
        Bu aktarımlar Kanun'un 9. maddesine uygun olarak; aktarımın yapılacağı
        ülke bakımından bir yeterlilik kararı bulunuyorsa bu karara, aksi hâlde
        Kişisel Verileri Koruma Kurulu tarafından ilan edilen standart sözleşme
        maddeleri gibi uygun güvencelere, bunların da bulunmadığı hâllerde açık
        rızanıza dayanılarak gerçekleştirilir. Standart sözleşme maddelerine
        dayanılan hâllerde, mevzuatta öngörülen süre içinde Kurul'a bildirim
        yapılır.
      </p>

      <h2 id="sesli-gorusme">9. Sesli Görüşmeler ve Çağrı Kaydı</h2>
      <p>
        Sesli asistan kullanıldığında, yanıt üretilebilmesi için görüşme sesi
        gerçek zamanlı olarak metne dönüştürülür. Bu işleme hizmetin sunulması
        için zorunludur ve yalnızca görüşme süresince gerçekleşir.
      </p>
      <p>
        <strong>Çağrı kaydı varsayılan olarak kapalıdır.</strong> Kayıt yalnızca
        asistanı işleten satıcının bu özelliği açıkça etkinleştirmesi hâlinde
        oluşturulur. Etkinleştirilmediği sürece ses kaydedilmez ve saklanmaz.
      </p>
      <p>
        Kayıt etkinleştirilmişse, görüşmenin başında arayan kişi kaydın alındığı
        konusunda bilgilendirilir. Kayıtlar satıcı tarafından belirlenen süre
        boyunca saklanır ve sürenin sonunda otomatik olarak silinir. Erişim,
        yetkili satıcı kullanıcıları ile sistemin işletilmesi için gerekli teknik
        personelle sınırlıdır.
      </p>
      <p>
        Ses verileri kimlik doğrulama, kimlik tespiti veya ses tanıma amacıyla
        <strong>kullanılmaz</strong> ve tarafımızca biyometrik veri olarak
        işlenmez.
      </p>

      <h2 id="otomatik">10. Otomatik Sistemlerle İşleme</h2>
      <p>
        Asistanlarımız, soruları yanıtlamak, uygun anlarda görüşme başlatmak,
        ürün önermek ve yapılandırılmışsa indirim kodu sunmak amacıyla site
        içindeki hareketleri otomatik olarak değerlendirir.
      </p>
      <p>
        Bu değerlendirmeler hakkınızda hukuki sonuç doğurmaz ve sizi benzer
        şekilde önemli ölçüde etkilemez. Bununla birlikte Kanun'un 11/g maddesi
        uyarınca, münhasıran otomatik sistemler vasıtasıyla analiz edilmesi
        suretiyle aleyhinize bir sonuç ortaya çıkmasına itiraz etme hakkına
        sahipsiniz. İtirazınızı aşağıdaki başvuru kanallarından iletebilirsiniz.
      </p>

      <h2 id="saklama">11. Saklama Süreleri</h2>
      <p>
        Kişisel verileriniz, işlenme amaçlarının gerektirdiği süre boyunca veya
        ilgili mevzuatta öngörülen süre kadar saklanır. Süre dolduğunda veriler
        Kanun'a uygun şekilde silinir, yok edilir veya anonim hâle getirilir.
      </p>
      <div class="ds-legal__table-wrap">
        <table class="ds-legal__table">
          <caption>Veri kategorilerine göre azami saklama süreleri.</caption>
          <thead>
            <tr>
              <th scope="col">Veri Kategorisi</th>
              <th scope="col">Saklama Süresi</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-label="Veri Kategorisi">Kimlik ve iletişim bilgileri</td>
              <td data-label="Saklama Süresi">İlişkinin sona ermesinden itibaren 5 yıl</td>
            </tr>
            <tr>
              <td data-label="Veri Kategorisi">İşlem güvenliği verileri (log kayıtları)</td>
              <td data-label="Saklama Süresi">2 yıl</td>
            </tr>
            <tr>
              <td data-label="Veri Kategorisi">Talep ve şikâyet bilgileri</td>
              <td data-label="Saklama Süresi">Talebin sonuçlanmasından itibaren 2 yıl</td>
            </tr>
            <tr>
              <td data-label="Veri Kategorisi">Görüşme içeriği</td>
              <td data-label="Saklama Süresi">Asistanı işleten satıcının belirlediği süre; belirlenmemişse varsayılan saklama süremiz</td>
            </tr>
            <tr>
              <td data-label="Veri Kategorisi">Çağrı kayıtları (etkinleştirilmişse)</td>
              <td data-label="Saklama Süresi">Satıcı tarafından belirlenen süre</td>
            </tr>
            <tr>
              <td data-label="Veri Kategorisi">Sözleşme ve fatura kayıtları</td>
              <td data-label="Saklama Süresi">Mevzuat gereği 10 yıl</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        Hesabınızı kapatmanız hâlinde, hesabınıza bağlı kişisel veriler, mevzuat
        gereği daha uzun süre saklanması gereken kayıtlar hariç olmak üzere,
        kapanışı takip eden makul süre içinde silinir veya geri döndürülemez
        şekilde anonim hâle getirilir.
      </p>

      <h2 id="guvenlik">12. Veri Güvenliği</h2>
      <p>
        Kişisel verilerinizi korumak amacıyla riske uygun teknik ve idari
        tedbirler uygulanmaktadır. Bu tedbirler; verilerin aktarım sırasında ve
        saklanırken şifrelenmesi, erişimin görevi gereği ihtiyaç duyan personelle
        sınırlandırılması, yönetsel işlemlerin loglanması ve güvenlik
        uygulamalarının düzenli olarak gözden geçirilmesini içerir.
      </p>
      <p>
        Elektronik ortamda hiçbir aktarım veya saklama yönteminin mutlak güvenlik
        sağlamadığı dikkate alınmalıdır; mevzuatın izin verdiği ölçüde mutlak
        güvenlik taahhüdünde bulunulmamaktadır.
      </p>

      <h2 id="ihlal">13. Veri İhlali Bildirimi</h2>
      <p>
        İşlenen kişisel verilerin kanuni olmayan yollarla başkaları tarafından
        elde edildiğinin tespit edilmesi hâlinde, durum öğrenildiği tarihten
        itibaren <strong>72 saat</strong> içinde Kişisel Verileri Koruma
        Kurulu'na bildirilir; etkilenen ilgili kişilere de belirlenebildikleri
        anda makul en kısa sürede uygun iletişim kanallarıyla bilgi verilir.
        İhlale ilişkin kapsam, etki ve alınan önlemler kayıt altına alınır.
      </p>

      <h2 id="haklariniz">14. İlgili Kişi Olarak Haklarınız</h2>
      <p>Kanun'un 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:</p>
      <app-kvkk-haklariniz></app-kvkk-haklariniz>
      <p>
        Verilerin, bir satıcı tarafından işletilen asistan aracılığıyla toplandığı
        hâllerde ilgili satıcı veri sorumlusudur; talebiniz bu durumda ilgili
        satıcıya yönlendirilir. Ayrıca Kişisel Verileri Koruma Kurumu'na şikâyette
        bulunma hakkınız saklıdır.
      </p>

      <h2 id="basvuru">15. Başvuru Yöntemleri</h2>
      <p>Haklarınıza ilişkin taleplerinizi;</p>
      <ul>
        <li>Sultan Selim Mah. Eski Büyükdere Cad. Silahtaroğlu Sok. Yaba Plaza 2 Kat:1, 4.Levent / İstanbul adresine bizzat veya noter kanalıyla,</li>
        <li>keyodijitala.s&#64;hs01.kep.tr KEP adresine,</li>
        <li><a href="mailto:info&#64;keyodigital.com">info&#64;keyodigital.com</a> adresine yazılı olarak,</li>
        <li>Güvenli elektronik imza veya mobil imza kullanarak elektronik ortamda,</li>
      </ul>
      <p>iletebilirsiniz.</p>
      <p>
        Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ uyarınca
        başvurunuzun geçerli sayılabilmesi için aşağıdaki bilgileri içermesi
        zorunludur:
      </p>
      <ul>
        <li>Ad, soyad ve başvuru yazılı ise imza,</li>
        <li>Türkiye Cumhuriyeti vatandaşları için T.C. kimlik numarası; yabancılar için uyruğu, pasaport numarası veya varsa kimlik numarası,</li>
        <li>Tebligata esas yerleşim yeri veya iş yeri adresi,</li>
        <li>Varsa bildirime esas elektronik posta adresi, telefon ve faks numarası,</li>
        <li>Talep konusu.</li>
      </ul>
      <p>
        İlgili kişi adına üçüncü kişilerce başvuru yapılabilmesi için noter
        kanalıyla düzenlenmiş özel vekâletname bulunması gerekmektedir.
      </p>

      <h2 id="degisiklik">16. Metindeki Değişiklikler</h2>
      <p>
        İşbu Aydınlatma Metni, mevzuattaki değişiklikler ve hizmetlerimizdeki
        güncellemeler doğrultusunda revize edilebilir. Güncel metin her zaman bu
        sayfada yayımlanır ve yukarıdaki "Son güncelleme" tarihi yenilenir.
      </p>

      <app-legal-links></app-legal-links>
    </div>
  </div>
</section>
